import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import {
  CREATE_SECTION_IN_FORM,
  DELETE_SECTION_URL,
  EDIT_SECTION_URL,
  get_headers,
  get_project_id,
  GET_SECTIONS_IN_FORM,
  get_token,
  QUESTION_TYPE_URLS,
  SECTIONS_LIST_URLS,
  ASSIGN_QUESTIONS_TO_FORM_SECTION,
  UNASSIGN_QUESTIONS_TO_FORM_SECTION,
  GET_QUESTIONS_IN_PROJECT,
  GET_FORM,
  GET_MAIN_SECTIONS
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "Sections",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
  },
  data: () => ({
    question_search: '',
    assign_section_id: null,
    section_types: [],
    token: get_token(),
    headers: get_headers(),
    section_id: "",
    project_id: get_project_id(),
    form_id: "",
    sub_active_tab: "Sections",
    sub_tabs: ["Sections", "Create Questions", "Preview Form"],
    section_list: [],
    section_table_headers: [],
    table_safe_section_list: [],
    show_edit_section_modal: false,
    current_edit_section: {
      id: null,
      name: '',
      order: null
    },
    section_name_error: false,
    general_error: '',
    sections: [],
    section_name: "",
    current_edit_index: null,
    show_assign_questions_modal: false,
    question_list: [],
    is_loading_questions: false,
    assign_question_table_headers: ['Question', 'Type', 'Number'],
    assign_questions_table: null,
    show_create_section_modal: false,
    main_sections: [],
    selected_main_section_id: "",
    main_section_error: false,
  }),

  computed: {
    filtered_data() {
      switch (this.sub_active_tab) {
        case "Sections":
          return this.create_sections;
        default:
          return [];
      }
    },

    filtered_questions() {
      if (!this.question_search) return this.question_list;

      const search_term = this.question_search.toLowerCase();
      return this.question_list.filter(question => {
        return (
          (question.question_text?.toLowerCase().includes(search_term)) ||
          (question.question_type?.question_type?.toLowerCase().includes(search_term)) ||
          (String(question.id).includes(search_term)) ||
          (String(question.question_number).includes(search_term))
        );
      });
    },

    assign_questions_table_data() {
      return this.question_list.map(q => ({
        id: q.id,
        Question: q.question_text,
        Type: this.format_question_type(q.question_type?.question_type || q.question_type),
        Number: q.id,
        is_assigned: q.is_assigned
      }));
    }
  },

  methods: {
    get_status_text(question) {
      return question.is_assigned ? 'Assigned' : 'Unassigned';
    },

    // Toggle switch handler for assigning/unassigning questions
    async on_toggle_assign(q) {
      if (q.is_loading) return;
      q.is_loading = true;
      try {
        if (q.is_assigned) {
          // Unassign
          await axios.post(UNASSIGN_QUESTIONS_TO_FORM_SECTION, {
            project_id: this.project_id,
            form_id: this.form_id,
            form_section_id: this.assign_section_id,
            question_ids: [q.id],
          }, { headers: this.headers });
          q.is_assigned = false;
          this.show_success("Question unassigned successfully");
        } else {
          // Assign
          await axios.post(ASSIGN_QUESTIONS_TO_FORM_SECTION, {
            project_id: this.project_id,
            form_id: this.form_id,
            section_id: this.assign_section_id,
            question_ids: [q.id],
          }, { headers: this.headers });
          q.is_assigned = true;
          this.show_success("Question assigned successfully");
        }
      } catch (error) {
        this.show_error(
          "Error updating assignment: " +
          (error.response?.data?.message || error.message)
        );
      } finally {
        q.is_loading = false;
      }
    },

    async open_assign_modal(section_id) {
      this.assign_section_id = section_id;
      this.is_loading_questions = true;
      this.show_assign_questions_modal = true;

      try {
        const [questions_response, form_response] = await Promise.all([
          axios.post(GET_QUESTIONS_IN_PROJECT, {
            project_id: this.project_id
          }, { headers: this.headers }),
          axios.get(GET_FORM, {
            headers: this.headers,
            params: { form_id: this.form_id }
          })
        ]);

        const all_questions = typeof questions_response.data === 'string'
          ? JSON.parse(questions_response.data).data
          : questions_response.data.data;

        const form_data = typeof form_response.data === 'string'
          ? JSON.parse(form_response.data).data
          : form_response.data.data;

        const current_section = form_data?.sections?.find(s => s.id === section_id);
        const assigned_questions = current_section?.questions || [];

        this.question_list = all_questions.map(q => {
          const assigned_in_section = assigned_questions.find(
            aq => aq.id === q.id || aq.question_text === q.question_text
          );
          const is_assigned = assigned_in_section ? !!assigned_in_section.is_assigned : false;
          return {
            ...q,
            is_assigned,
            is_loading: false
          };
        });

      } catch (error) {
        this.show_error(`Error getting questions: ${error.response?.data?.message || error.message}`);
        this.question_list = [];
      } finally {
        this.is_loading_questions = false;
      }
    },

    close_assign_modal() {
      this.show_assign_questions_modal = false;
    },

    fetch_sections() {
      axios.get(SECTIONS_LIST_URLS, { headers: this.headers })
        .then(response => {
          this.section_types = response.data.data || [];
        })
        .catch(error => {
          this.show_error(
            "Error fetching sections: " +
            (error.response?.data?.message || error.message)
          );
        });
    },

    async create_section() {
      // Validate section name
      if (!this.section_name.trim()) {
        this.section_name_error = true;
        this.show_error("Section name is required");
        return;
      }

      // Validate main section selection
      if (!this.selected_main_section_id) {
        this.main_section_error = true;
        this.show_error("Main section selection is required");
        return;
      }

      axios.post(CREATE_SECTION_IN_FORM, {
        project_id: this.project_id,
        form_id: this.form_id,
        main_section_id: this.selected_main_section_id,
        section_name: this.section_name.trim(),
      }, { headers: this.headers })
      .then(() => {
        this.show_success(`Section "${this.section_name}" created successfully`);
        // Reset form fields
        this.section_name = "";
        this.selected_main_section_id = "";
        this.section_name_error = false;
        this.main_section_error = false;
        // Refresh table
        this.get_sections();
        // Close modal
        this.show_create_section_modal = false;
      })
      .catch(error => {
        this.show_error("Error creating section: " +
          (error.response?.data?.message || error.message));
      });
    },


    open_edit_section_modal(row) {
      this.current_edit_section = {
        id: row.id,
        name: row.section_name,
        order: row.order || 1
      };
      this.show_edit_section_modal = true;
    },

    async save_edited_section() {
      if (!this.current_edit_section?.id) {
        this.show_error("Section ID is missing");
        return;
      }

      if (!this.current_edit_section.name?.trim()) {
        this.section_name_error = true;
        this.show_error("Section name is required");
        return;
      }

      const payload = {
        name: this.current_edit_section.name.trim(),
        section_id: this.current_edit_section.id
      };

      try {
        const response = await axios.put(`${EDIT_SECTION_URL}`, payload, {
          headers: this.headers
        });

        const response_data = typeof response.data === 'string'
          ? JSON.parse(response.data)
          : response.data;

        if (response_data.status === 'success') {
          this.show_edit_section_modal = false;
          this.show_success(response_data.message || 'Section updated successfully');
          this.get_sections();
        } else {
          this.show_error(response_data.message || 'Failed to update section');
        }
      } catch (error) {
        let error_message = "Failed to update section";
        if (error.response) {
          try {
            const error_data = typeof error.response.data === 'string'
              ? JSON.parse(error.response.data)
              : error.response.data;

            error_message = error_data?.message ||
              error_data?.detail ||
              (error_data?.errors ? JSON.stringify(error_data.errors) : 'Update failed');
          } catch (e) {
            error_message = error.response.data || 'Update failed';
          }
        }
        this.show_error(error_message);
      }
    },

    assign_question(section_id) {
      if (!this.form_id) {
        this.show_error('Please save the form first before assigning questions');
        return;
      }

      sessionStorage.setItem('current_form_id', this.form_id);
      sessionStorage.setItem('current_section_id', section_id);

      this.$router.push({
        path: '/manage_questions',
        query: {
          form_id: this.form_id,
          section_id: section_id,
          project_id: this.project_id
        }
      });
    },

    delete_section(section_id) {
      Swal.fire({
        title: 'Delete Section?',
        text: 'This will also delete all questions in this section',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.is_confirmed) {
          axios.delete(DELETE_SECTION_URL, {
            data: { section_id: section_id },
            headers: this.headers
          })
            .then(response => {
              if (response.data?.status === 'success') {
                Swal.fire('Deleted!', response.data.message || 'Section deleted successfully', 'success');
                this.get_sections();
              } else {
                Swal.fire('Error', response.data?.message || 'Failed to delete section', 'error');
              }
            })
            .catch(error => {
              const error_message = error.response?.data?.message ||
                error.message ||
                'Failed to delete section';
              Swal.fire('Error', error_message, 'error');
            });
        }
      });
    },

    async get_data_point_types() {
      await axios.get(QUESTION_TYPE_URLS, {
          headers: this.headers
        })
        .then(response => {
          const my_types = JSON.parse(response.data);
          this.question_types = my_types.data.map((item) => ({
          ...item,
          formatted_type: this.format_question_type(item.question_type),
        }));
        })
        .catch (error => {
          this.show_error("Error retrieving question types: " + error.message);
        })
      },

    async get_sections() {
      this.section_list = [];
      const payload = { form_id: this.form_id };

      try {
        const response = await axios.post(GET_SECTIONS_IN_FORM, payload, {
          headers: this.headers
        });

        if (response.data?.data?.length) {
          this.section_list = response.data.data;
          this.prep_tables();
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          this.show_error("Error getting sections: " +
            (error.response?.data?.message || error.message));
        }
      }
    },

    async fetch_main_sections() {
      const response = await axios.get(GET_MAIN_SECTIONS, {
        params: { project_id: this.project_id },
        headers: this.headers
      });
      this.main_sections = response.data.data || [];
    },

    prep_tables() {
      if (this.section_list.length > 0) {
        this.table_safe_section_list = this.section_list.map((section) => ({
          id: section.section_id,
          section_name: section.section_name,
        }));
        this.section_table_headers = Object.keys(this.table_safe_section_list[0])
          .map(key => key === 'section_name' ? 'Section Name' : key);
      }
      this.initialize_data_table();
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_ids = {
          Sections: "#create-sections-table"
        };

        const table_id = table_ids[this.sub_active_tab];
        if (!table_id) return;

        const table_element = document.querySelector(table_id);
        if (!table_element) return;

        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }

        $(table_id).DataTable({
          responsive: true,
          destroy: true
        });
      });
    }
  },
  mounted() {
    this.form_id = this.$route.query.form_id;
    this.headers = get_headers();
    this.get_sections();
    this.get_data_point_types();
    this.initialize_data_table();
    this.fetch_main_sections();
  },
  watch: {
    create_sections() {
      this.initialize_data_table();
    }
  },
  beforeDestroy() {
    if (this.assign_questions_table) {
      this.assign_questions_table.destroy(true);
    }
  }
};